export const THREE_SECONDS = 3000;